import {
  UpdateOrderItemsInput,
  UpdateOrderItemsOutput,
} from "@redotech/redo-order-editing-common/schemas/update-order-items";

export const updateOrderSelfServe = {
  name: "updateOrderSelfServe" as const,
  input: UpdateOrderItemsInput,
  output: UpdateOrderItemsOutput,
};
